import { useCompanyConfiguration } from 'init/use-company-configuration';
import { useProfile } from 'init/use-enforce-profile';
import { isNullish, isTruthy } from 'remeda';
import { useLoadExternalMailboxes } from 'shared/hooks/use-load-external-mailboxes';

export const useCanSendMail = () => {
  const profile = useProfile();
  const company = useCompanyConfiguration();

  const { externalMailboxes } = useLoadExternalMailboxes();

  const hasPackageRight = company.package.can_use_external_mails;
  const hasEmailRight = profile.roles.includes('admin') || profile.roles.includes('mail');
  const customDomain = company.custom_domain;

  const mailboxes = externalMailboxes.data.filter(
    m => customDomain && m.attributes.login?.includes(customDomain),
  );
  const isSameDomain = isNullish(customDomain)
    ? false
    : mailboxes.some(mailbox => mailbox.attributes.login?.includes(customDomain));

  const canUseExternalMail = isTruthy(
    hasPackageRight && hasEmailRight && customDomain && isSameDomain,
  );

  return { canUseExternalMail, customDomain, isSameDomain, mailboxes };
};
